var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "VueSlickgrid",
    {
      ref: "grid",
      attrs: {
        name: _vm.gridName,
        headerTitle: _vm.messages.title,
        items: _vm.ds,
        "checkbox-row-selection": "",
        "export-to-csv": "",
        exportToCsvFilename: _vm.messages.exportFilename,
        "footer-totals": "",
        columnDefaults: _vm.b_7315092382398562_columnDefaults,
        columns: _vm.b_7315092382398562_columns
      },
      on: {
        selectedRowsChanged: function($event) {
          return _vm.evh_7315092382398562_selectedRowsChanged($event, {})
        },
        command: function($event) {
          return _vm.evh_7315092382398562_command($event, {})
        }
      }
    },
    [
      _c(
        "DIV",
        {
          staticClass: "flex-grow-1 d-flex border-left px-3",
          attrs: { slot: "toolbar" },
          slot: "toolbar"
        },
        [
          _c(
            "b-dropdown",
            { attrs: { size: "sm", "toggle-class": "btn-light border" } },
            [
              _c(
                "template",
                { slot: "button-content" },
                [
                  _c("ItpIcon", {
                    staticClass: "mx-1",
                    attrs: { icon: _vm.$config.billingList.createItemIcon }
                  }),
                  _vm._v(" "),
                  _c("ItpText", {
                    attrs: {
                      text: _vm._f("pgettext")("Billing plan", "BillingList")
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("ItpNavItem", {
                attrs: {
                  icon: _vm.$config.billingList.createItemIcon,
                  text: _vm._f("pgettext")(
                    "Create billing plan...",
                    "BillingList"
                  ),
                  size: "sm",
                  "dropdown-item": ""
                },
                on: {
                  click: function($event) {
                    return _vm.evh_8320016629450276_click($event, {})
                  }
                }
              }),
              _vm._v(" "),
              _c("ItpNavItem", {
                attrs: {
                  icon: _vm.$config.billingList.createItemIcon,
                  text: _vm._f("pgettext")("Add item...", "BillingList"),
                  size: "sm",
                  "dropdown-item": ""
                },
                on: {
                  click: function($event) {
                    return _vm.evh_6705964765214521_click($event, {})
                  }
                }
              }),
              _vm._v(" "),
              _c("ItpNavItem", {
                attrs: {
                  icon: _vm.$config.billingList.createItemIcon,
                  text: _vm._f("pgettext")("Copy items...", "BillingList"),
                  size: "sm",
                  disabled: !_vm.selectedItems || !_vm.selectedItems.length,
                  "dropdown-item": ""
                },
                on: {
                  click: function($event) {
                    return _vm.evh_6806515264385235_click($event, {})
                  }
                }
              }),
              _vm._v(" "),
              _c("ItpNavItem", {
                attrs: {
                  icon: "fa-trash",
                  text: _vm._f("gettext")("Delete"),
                  size: "sm",
                  disabled: !_vm.selectedItems || !_vm.selectedItems.length,
                  spinning: _vm.actions.deleteItems.isRunning,
                  "dropdown-item": ""
                },
                on: {
                  click: function($event) {
                    return _vm.evh_8116269939469002_click($event, {})
                  }
                }
              }),
              _vm._v(" "),
              _c("ItpNavItem", {
                attrs: {
                  icon: _vm.$config.billingList.createItemIcon,
                  text: _vm._f("pgettext")("Bulk edit...", "BillingList"),
                  size: "sm",
                  disabled: !_vm.selectedItems || !_vm.selectedItems.length,
                  spinning: _vm.actions.deleteItems.isRunning,
                  "dropdown-item": ""
                },
                on: {
                  click: function($event) {
                    return _vm.evh_5900129514656303_click($event, {})
                  }
                }
              }),
              _vm._v(" "),
              _c("ItpNavItem", {
                attrs: {
                  icon: _vm.$config.uploadIcon,
                  text: _vm._f("pgettext")("Bulk upload...", "BillingList"),
                  size: "sm",
                  "dropdown-item": ""
                },
                on: {
                  click: function($event) {
                    return _vm.evh_1655522927138420_click($event, {})
                  }
                }
              })
            ],
            2
          ),
          _vm._v(" "),
          _c("JobHandlerControl", {
            staticClass: "ml-3",
            attrs: {
              size: "sm",
              jobType: "invoice_generation_from_billing_list",
              "load-current": "",
              payload: _vm.onCreateInvoicesPayload,
              icon: "mdi:cog",
              text: _vm._f("pgettext")(
                "Generate invoices",
                "BillingList|Submit"
              ),
              disabled: !_vm.selectedItems || !_vm.selectedItems.length
            },
            on: {
              success: function($event) {
                return _vm.evh_3343864469950044_success($event, {})
              }
            }
          }),
          _vm._v(" "),
          _c("ItpButton", {
            staticClass: "ml-3",
            attrs: {
              icon: _vm.$config.mergeIcon,
              text: _vm._f("gettext")("Merge invoices"),
              size: "sm",
              variant: "light",
              disabled: !_vm.selectedItems || !_vm.selectedItems.length,
              spinning: _vm.actions.mergeInvoices.isRunning
            },
            on: {
              click: function($event) {
                return _vm.evh_1889980785424776_click($event, {})
              }
            }
          }),
          _vm._v(" "),
          _c("ItpButton", {
            staticClass: "ml-3",
            attrs: {
              icon: "fa-trash",
              text: _vm._f("gettext")("Delete invoices"),
              size: "sm",
              variant: "light",
              disabled: !_vm.selectedItems || !_vm.selectedItems.length,
              spinning: _vm.actions.deleteInvoices.isRunning
            },
            on: {
              click: function($event) {
                return _vm.evh_4892266742011185_click($event, {})
              }
            }
          }),
          _vm._v(" "),
          _c("ArtifactJob", {
            staticClass: "ml-3",
            attrs: {
              icon: "ic:baseline-download",
              text: _vm._f("gettext")("Download views"),
              size: "sm",
              disabled: !_vm.selectedItems || !_vm.selectedItems.length,
              operation: "download_invoice_views",
              payload: _vm.boundDownloadViewsPayloadMethod()
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }